import { Navigate, Outlet } from "react-router-dom";
import { SessionStorageData } from "../utils/helper";
import SidebarHeader from "../pages/sidebar";

function PrivateRoute() {
    let isAuth = SessionStorageData();
    return isAuth ? <SidebarHeader /> : <Navigate to={{ pathname: "/login" }} />;
}

export default PrivateRoute;